import { URL_MULTIPLE_FILTER_VALUE_SEPARATOR } from '../../../constants';
import type { CheckboxValue, Facet } from '../../interfaces/facets';

export function generateCheckboxUrlValue(
  facet: Facet,
  selectedValues: CheckboxValue,
): string {
  let nextURLValue = '';

  const selectedFacetValues = facet?.values.filter(({ name }) =>
    selectedValues.split(',').includes(name),
  );

  if (selectedFacetValues.length) {
    nextURLValue = selectedFacetValues.map((value) => value.name).join(',');
    const refinedFacetValues = facet?.values.filter(
      ({ isRefined }) => isRefined,
    );

    const refinedValues: string[] =
      refinedFacetValues?.map((refinedValue) => refinedValue.name) || [];

    nextURLValue = selectedFacetValues.some((value) => value.isRefined)
      ? refinedValues
          ?.filter(
            (refinedValue) =>
              !selectedFacetValues
                .map((value) => value.name)
                .includes(refinedValue),
          )
          .join(URL_MULTIPLE_FILTER_VALUE_SEPARATOR)
      : [
          ...refinedValues,
          ...selectedFacetValues.map((value) => value.name),
        ].join(URL_MULTIPLE_FILTER_VALUE_SEPARATOR);
  }
  return nextURLValue;
}
